import Currency from 'components/Currency/Currency';
import CustomLink from 'components/TableLink';
import { tableStyles } from 'css/tableStyles';
import React from 'react';
import DataTable from 'components/DataTable';

const columns = [
  {
    name: 'Item Id',
    selector: 'inventoryItem.objectId',
    // eslint-disable-next-line react/display-name
    cell: (row) => 
      <CustomLink
        text={row.inventoryItem.objectId}
        linkTo={`/inventory-items/${row.inventoryItem.objectId}`}
      />,
  },
  {
    name: 'Item Name',
    selector: 'inventoryItem.name',
  },
  {
    name: 'Quanity',
    selector: 'quantity',
  },
  {
    name: 'Unit',
    selector: 'inventoryItem.unit.description',
  },
  {
    name: 'Price (per item)',
    selector: 'inventoryItem.price',
    // eslint-disable-next-line react/display-name
    cell: (row) => <Currency amount={row.inventoryItem.price} />,
  },
  {
    name: 'Total Price',
    selector: 'totalPrice',
    // eslint-disable-next-line react/display-name
    cell: (row) => <Currency amount={row.totalPrice} />,
  },
  {
    name: 'Category',
    selector: 'inventoryItem.category.description',
  },
];

const WeeklyData = (props) => {
  return (
    <div className="m-4">
      <DataTable
        noHeader
        data={props.data.weeklyData}
        columns={columns}
        customStyles={tableStyles}
      />
    </div>
  );
};

export default WeeklyData;